import React from "react";

const qoder = window.qoder;
qoder.config.url =
  "https://qoder.byteark.com/apps/LnWakXMrQpfLkElk97Jz?access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.ycuGXKSpHhxYiv1CBG-iyBib0U4dUo1smsqhBENhO4A";

export function BrowseVideo({ videoKey = "", onUploadVideo }) {
  const handleClick = (e) => {
    try {
      qoder.browseVideo(function (video) {
        onUploadVideo(video.key);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const url = videoKey
    ? `http://true4u-kgjwb7.cdn.byteark.com/videos/${videoKey}/embedded`
    : "";

  return (
    <div className="flex w-full">
      <button
        onClick={handleClick}
        type="button"
        className="mr-2 border text-sm px-3 py-1 rounded flex items-center"
      >
        Select Video
      </button>
      <input className="border flex-1 px-2 py-1 rounded" readOnly value={url} />
    </div>
  );
}
